import { distance } from "fastest-levenshtein";

// Compares a Track project display name against an OpenSpace site name.
// Punctuation and spacing are stripped before comparing so "Acme HQ" and
// "acme-hq" agree. Numbers are the most meaningful part of sibling site
// names ("Phase 1" vs "Phase 2"), so digit sequences must match exactly;
// the similarity threshold only forgives typos in the words around them.
const normalize = (name: string): string =>
  name
    .toLowerCase()
    .normalize("NFD") // split accented letters so the accents can be dropped
    .replace(/\p{M}/gu, "")
    .replace(/[^\p{L}\p{N}]/gu, "");

const digitSequence = (name: string): string =>
  (name.match(/\d+/g) ?? []).map(Number).join(",");

const SIMILARITY_THRESHOLD = 0.85;

export const namesRoughlyMatch = (a: string, b: string): boolean => {
  const normalizedA = normalize(a);
  const normalizedB = normalize(b);
  if (!normalizedA || !normalizedB) {
    return false;
  }
  if (digitSequence(normalizedA) !== digitSequence(normalizedB)) {
    return false;
  }
  const maxLength = Math.max(normalizedA.length, normalizedB.length);
  return (
    1 - distance(normalizedA, normalizedB) / maxLength >= SIMILARITY_THRESHOLD
  );
};
